const svgToEnglish = icon => {
  /*
    Yeah, there is a story behind this one..
    Icons are all in english except here. Here there in dutch and with a icon prefix
    The backend needs to return the english name, but for now we map it to english.
  */
  switch (icon) {
    case 'icon-aanbod':
      return 'car';
    case 'icon-sleutel':
      return 'key';
    case 'icon-voorwaarden':
      return 'documents';
    case 'icon-onderhoud':
      return 'maintenance';
    case 'icon-contract':
      return 'contract';
    case 'icon-schade':
      return 'damage';
    case 'icon-financieel':
      return 'wallet';
    case 'icon-levertijd':
      return 'delivery_time';
    default:
      return '';
  }
};

export default svgToEnglish;
